export default __webpack_public_path__ + "static/067-52be8b09f4419d8551a69127514574a4.jpg";